import { useState } from 'react'
import { useAuth } from '../state/auth'
import { useNavigate, Link } from 'react-router-dom'
import './login.css'

export default function Register() {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')
    const [err, setErr] = useState(null)
    const register = useAuth(s => s.register)
    const navigate = useNavigate()
    const submit = async e => {
        e.preventDefault()
        setErr(null)
        try {
            await register(name.trim(), email.trim(), password, password2)
            navigate('/projects')
        } catch (e) {
            setErr(e.message || 'Registration failed')
        }
    }
    return (
        <div className="auth-wrap">
            <form className="auth-card" onSubmit={submit}>
                <h1>Create account</h1>
                {err && <div className="error">{err}</div>}
                <label>Name</label>
                <input value={name} onChange={e=>setName(e.target.value)} autoFocus />
                <label>Email</label>
                <input value={email} onChange={e=>setEmail(e.target.value)} type="email" />
                <label>Password</label>
                <input value={password} onChange={e=>setPassword(e.target.value)} type="password" />
                <label>Password again</label>
                <input value={password2} onChange={e=>setPassword2(e.target.value)} type="password" />
                <button type="submit">Sign up</button>
                <div style={{marginTop:12,fontSize:13,opacity:.8}}>
                    Already have an account? <Link to="/login">Sign in</Link>
                </div>
            </form>
        </div>
    )
}
